let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2YGYU"), load("cGtlr"), load("cmxKv"), load("iWwAC"), load("5bnGf"), load("97s9d"), load("jjWia")]).then(() => parcelRequire('c8BWz'));